export const workScheduleColor = {
  true: '#8BC34A',
  false: '#9E9E9E',
}
